import { ReduxState } from '../types';

const getOneIdentityUrl = (state: ReduxState) =>
  state.getIn(['config', 'oneIdentityUrl']) as string;

export default getOneIdentityUrl;
